import {
  maxLength,
  required,
} from '@rxweb/reactive-form-validators';

export class AddAddressModel {
  /* @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 20, message: 'No puede tener más de 20 caracteres.' })
    firstName: string;

    @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 20, message: 'No puede tener más de 20 caracteres.' })
    lastName: string;*/

    @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 25, message: 'El nombre no puede tener más de 25 caracteres.' })
    name: string;

    @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 100, message: 'El departamento puede tener más de 100 caracteres.' })
    department: string;

    @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 100, message: 'La ciudad no puede tener más de 100 caracteres.' })
    city: string;

    @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 50, message: 'La dirección no puede tener más de 50 caracteres.' })
    address: string;
}
